import React, { useEffect, useState } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function HistoryBills() {
  const [history, setHistory] = useState([]);
  const [rating, setRating] = useState("");
  const [feedback, setFeedback] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [recordId, setRecordId] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const userPhone = localStorage.getItem("userPhone");

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr; // fallback: show original value if invalid
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

 useEffect(() => {
  const fetchFromAirtable = async () => {
    try {
      const res = await fetch(
        `${AIRTABLE_URL}?filterByFormula={phone}='${userPhone}'`,
        {
          headers: AIRTABLE_HEADERS, // ✅ sirf ye rakha
        }
      );
      const json = await res.json();

      const parsed = json.records
        .map((rec) => ({
          id: rec.id,
          ...rec.fields,
        }))
        .filter(
          (b) =>
            b.phone === userPhone &&
            (b.paid === true || b.paid === "TRUE" || b.paid === "true") &&
            b.paymentTransferred
        );

      setHistory(parsed);
      localStorage.setItem("bookingHistory", JSON.stringify(parsed));
    } catch (err) {
      console.error("❌ Error fetching booking history:", err);
    }
  };

  fetchFromAirtable();
  const interval = setInterval(fetchFromAirtable, 8000);
  return () => clearInterval(interval);
}, [userPhone]);

const handleRateClick = async (orderId) => {
  const res = await fetch(
    `${AIRTABLE_URL}?filterByFormula={orderId}='${orderId}'`,
    {
      headers: AIRTABLE_HEADERS, // ✅ yaha bhi sirf ye rakha
    }
  );
  const json = await res.json();
  if (json.records.length > 0) {
    const rec = json.records[0];
    setRecordId(rec.id);
    setSelectedOrderId(orderId);
    if (rec.fields.feedback || rec.fields.rating) {
      setAlreadySubmitted(true);
    } else {
      setAlreadySubmitted(false);
    }
  }
};


const handleFeedbackSubmit = async () => {
  if (!rating || !feedback) {
    alert("Please enter both rating and feedback.");
    return;
  }

  if (!recordId) {
    alert("Record not found.");
    return;
  }

  try {
    const res = await fetch(`${AIRTABLE_URL}/${recordId}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS,
  body: JSON.stringify({
    fields: {
      rating: String(rating),
      feedback,
    },
  }),
});

    const data = await res.json();

    if (res.ok) {
      alert("✅ Feedback submitted successfully!");
      setAlreadySubmitted(true);
    } else {
      const errorMessage =
        data?.error?.message || "Unknown error from Airtable.";
      alert(`❌ Failed to submit: ${errorMessage}`);
      console.error("Airtable Error Detail:", data);
    }
  } catch (err) {
    console.error("❌ Network or parsing error:", err);
    alert("⚠️ Something went wrong while submitting feedback.");
  }
};


  const parsePrice = (str) => {
    if (!str) return 0;
    const matches = [...str.matchAll(/₹\s?(\d+)(?:\s?[x×]\s?(\d+))?/gi)];
    return matches.reduce((total, match) => {
      const amount = parseInt(match[1], 10);
      const quantity = match[2] ? parseInt(match[2], 10) : 1;
      return total + amount * quantity;
    }, 0);
  };

  const completedBookings = history.filter(
    (b) =>
      (b.paid === true || b.paid === "TRUE" || b.paid === "true") &&
      b.phone === userPhone
  );

  return (
    <div
      style={{
        padding: "60px 3px",
        textAlign: "left",
        position: "relative",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <h2 style={{ textAlign: "left" }}>📜 History Bills</h2>
      {completedBookings.length === 0 ? (
        <p>No completed or paid bookings yet.</p>
      ) : (
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {completedBookings.map((booking, index) => {
            const serviceLine = Array.isArray(booking.services)
              ? booking.services.join(", ")
              : booking.services || "";

            const serviceTotal = parsePrice(serviceLine);
            const extraTotal = booking.extraParts
              ? parsePrice(booking.extraParts)
              : 0;
            const grandTotal = serviceTotal + extraTotal;

            return (
              <li
                key={`${booking.orderId}-${index}`}
                style={{
                  border: "1px solid #ccc",
                  padding: 10,
                  marginBottom: 10,
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  textAlign: "left",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <p><b>Order ID:</b> {booking.orderId}</p>
                <p><b>Name:</b> {booking.name}</p>
                <p><b>Services:</b> {booking.services}</p>
                <p><b>Service Total:</b> ₹{serviceTotal}</p>
                {booking.extraParts && (
                  <>
                    <p><b>Extra Parts:</b> {booking.extraParts}</p>
                    <p><b>Extra Parts Total:</b> ₹{extraTotal}</p>
                  </>
                )}
                
                <p><b>Grand Total:</b> ₹{grandTotal}</p>
                <p><b>Slot:</b> {formatDate(booking.slot)}</p>
                {booking.approved && (
                  <p style={{ color: "green" }}>✔️ Approved</p>
                )}
                {booking.workCompleted && (
                  <p style={{ color: "green" }}>✅ Work Completed</p>
                )}
                {booking.paid && (
                  <p style={{ color: "green" }}>💰 Paid</p>
                )}

                {/* ⭐ Feedback Form Inline */}
                {booking.paid && selectedOrderId === booking.orderId ? (
                  alreadySubmitted ? (
                    <p style={{ marginTop: 10, color: "green", fontWeight: "bold" }}>
                  
                    </p>
                  ) : (
   <div style={{ marginTop: 10 }}>
  <p><b>Give Rating:</b></p>
  <div style={{ fontSize: "36px", letterSpacing: "8px" }}>
    {[1, 2, 3, 4, 5].map((num) => (
      <span
        key={num}
        onClick={() => setRating(num)}
        style={{
          cursor: "pointer",
          color: num <= rating ? "#f39c12" : "#ccc",
          padding: "0 6px",
          transition: "color 0.2s",
        }}
      >
        ★
      </span>
    ))}
  </div>
  <br />
  <textarea
    placeholder="✍️ Enter your feedback"
    value={feedback}
    onChange={(e) => setFeedback(e.target.value)}
    rows={3}
    style={{ width: "100%", padding: 8 }}
  />
  <button
    onClick={handleFeedbackSubmit}
    style={{
      marginTop: 10,
      backgroundColor: "#28a745",
      color: "white",
      padding: "6px 12px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    }}
  >
    ✅ Submit Feedback
  </button>

                    </div>
                  )
                ) : booking.paid && !booking.rating ? (
                  <button
                    onClick={() => handleRateClick(booking.orderId)}
                    style={{
                      marginTop: 10,
                      backgroundColor: "#f39c12",
                      color: "white",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    ⭐ Rate Service
                  </button>
                ) : (
                  <p style={{ marginTop: 10, color: "green", fontWeight: "bold" }}>
                  
                  </p>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}